module.exports = __webpack_public_path__ + "img/layout_horizontal_right.b42193d0.svg";